import type { Meta, StoryObj } from '@storybook/web-components';
const meta: Meta = {
  title: 'Full Page Examples',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: 'Another description, overriding the comments',
      },
    },
  },
};

export default meta;
type Story = StoryObj;

/**
 * # Primary Button
 * This is the primary button
 */
export const BasicExample: Story = {
  parameters: {
    docs: {
      description: {
        story: 'Another description on the story, overriding the comments',
      },
    },
  },
  render: () => `<style>
  html,body {
    font-size: 14px;
    font-family: "Helvetica", "Arial", sans-serif;
    line-height: 1.2;
  }
  
  @media screen and (min-width: 768px) {
    html,body {
        font-size:16px
    }
  }

  content-navigation-block ul,
  content-navigation-block ol,
  content-navigation-block li {
    padding: 0;
    list-style: none;
    display: block;
  }

  content-navigation-block .nav-level-1 a {
    font-size: 1.15rem;
    line-height:2;
    text-decoration: none;
    font-weight: bold;
  }
  
  .logo {
    width: 100px;
    height: 100px;
    background: #888;
    color: #FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden;
  }
  
  .page-wrapper {
    max-width: 1366px;
    margin: auto
  }
  
  .text-style--header-1 {
    font-weight: bold;
    text-transform: uppercase;
    line-height: 1.2;
    font-size: 3.5rem;
  }
  
  .text-style--header-2 {
    font-size: 24px;
    text-transform: uppercase;
    font-weight: bold
  }

  .text-style--header {
    font-weight: bold;
    text-transform: uppercase;
    line-height: 1;
    font-size: 2.5rem;
  }
  
  .text-style--subheader {
    font-size: 24px;
    line-height: 1
  }
  
  
  .text-style--small-copy {
    font-size: 12px;
    text-transform: uppercase
  }
  
  .text-style--tout-media-content {
    color: white;
    font-size: 12px
  }
  
  .button {
    display: inline-flex;
    text-decoration: none;
  }
  
  .button a {
    color: inherit;
    font-size: inherit;
    text-decoration: inherit; 
  }
  
  content-button a {
    width: auto;
  }
  .button--primary a {
    background: black;
    color: white;
    height: 50px;
    padding: 0 30px;
    width: auto;
  }
  
  .button--primary a:hover {
    background: #333
  }
  
  .button--play {
    color: white;
    font-size: 32px;
    font-weight: bold
  }
  
  .link a {
    text-decoration: none;
    color: inherit
  }
  
  .link:hover a {
    color: red
  }
  
  .link--large a {
    font-weight: bold;
    font-size: 32px
  }
  
  .grid--spaced .content-grid-formatter-grid {
    grid-column-gap: 15px;
    grid-row-gap: 15px
  }
  
  .grid--cast .content-grid-formatter-grid>content-tout-block {
    margin-bottom: 20px
  }
  
  .text-style--large-copy {
    font-size: 24px;
    line-height: 1.3
  }

  .swiper-button-prev {
    left: 0
  }
  
  .swiper-button-next {
    right: 0
  }
  
  .swiper-button-next,.swiper-button-prev {
    width: 64px;
    height: 64px;
    background: rgba(0,0,0,0.6)
  }
  
  .swiper-button-next:after,.swiper-button-prev:after {
    color: white
  }
  
  .swiper-scrollbar {
    display: none
  }
  
  
  content-spacer.hydrated,content-text-block.hydrated,content-tout-block.hydrated, content-hero-block.hydrated, content-image.hydrated {
    opacity: 1;
  }
  .relative {
    position: relative;
  }
  content-navigation-block[aria-expanded="true"] .logo {
    display: none;
  }

  </style>
    <div class="page-wrapper">
    <div class="">
    <content-spacer max-width="1440px" horizontal="center">
    <content-navigation-block hamburger="fixed|none" flex-shrink="true">
    <content-button slot="skipContent">Skip to main content</content-button>
    <div slot="content">
      <nav>
      <content-spacer left-offset="40px|0">
        <content-grid-formatter class="nav-level-1" columns="1|5" vertical="center" type="flex|grid" horizontal="flex-start|flex-end">
          <div style="margin-right: auto;"><content-line classes="logo">Logo</content-line></div>
          <div><content-button href="#link1" target="_blank">Link 1
          </content-button>
          <content-overlay id="link1" full-screen="false" position="static|absolute">
          <content-spacer left-offset="20px" right-offset="20px">
            <content-grid-formatter columns="1|3">
            <ul class="nav-level-2">
            <li><a href="#">Link</a></li>
            <li><a href="#">Link</a></li>
            <li><a href="#">Link</a></li>
            </ul>
            <ul class="nav-level-2">
            <li><a href="#">Link</a></li>
            <li><a href="#">Link</a></li>
            <li><a href="#">Link</a></li>
            </ul>
            <ul class="nav-level-2">
            <li><a href="#">Link</a></li>
            <li><a href="#">Link</a></li>
            <li><a href="#">Link</a></li>
            </ul>
            </content-grid-formatter>
          </content-spacer>
        </content-overlay>
        </div>
        <div>
          <content-button href="#link2" target="_blank">Link 2</content-button>
          </div>
        </content-grid-formatter>
        </content-spacer>
        </nav>
      </div>
      </content-navigation-block>
      </content-spacer>
      </div>
      <content-text-block slot="header">
        <content-spacer max-width="90" horizontal="left" text-align="left">
          <content-line classes="text-style--header-1">Latest Works</content-line>
        </content-spacer>
      </content-text-block>
          
    <content-spacer top-offset="1" bottom-offset="20px">
    <content-hero-block content-position="above">
      <content-image slot="background" src="https://picsum.photos/1600/900?random=4&grayscale"></content-image>
      <content-text-block slot="content" vertical="center">
        <content-spacer left-offset="4" right-offset="4"  max-width="100|75|65">
          <content-line classes="text-style--header">Watch Travel Video</content-line>
          <content-spacer top-offset="4">
            <content-button classes="button button--play" href="#heroVideoOverlay">PLAY</content-button>
          </content-spacer>
        </content-spacer>
        </content-text-block>
        <content-overlay id="heroVideoOverlay" position="absolute">
        Hello World
        <script slot="content" type="text/template">
          <content-video fit-container="true" src="https://www.youtube.com/watch?v=IY4x85zqoJM" autoplay="true"></content-video>
          </script>
        </content-overlay>
    </content-hero-block>
  </content-spacer>

      <content-grid-formatter class="grid--cast" columns="2|4" type="grid" column-gap="10px" row-gap="10px">
        <content-tout-block hover="false">
          <content-image slot="media" alt="Test Alt Text" lazy-load="false" width="2" height="3" aspect-ratio="2/3" src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4"></content-image>
          <content-text-block slot="mediaContent" vertical="bottom">
            <content-spacer text-align="left" left-offset="4" bottom-offset="4">
              <content-line classes="text-style--tout-media-content">Tourist Destination</content-line>
              <content-line classes="text-style--tout-media-content">Malaysia</content-line>
            </content-spacer>
          </content-text-block>  
        </content-tout-block>
        <content-tout-block hover="false">
          <content-image slot="media" alt="Test Alt Text" lazy-load="false" width="2" height="3" aspect-ratio="2/3" src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4" aspect-ratio="2/3"></content-image>
          <content-text-block slot="mediaContent" vertical="bottom">
            <content-spacer text-align="left" left-offset="4" bottom-offset="4">
              <content-line classes="text-style--tout-media-content">Tourist Destination</content-line>
              <content-line classes="text-style--tout-media-content">Malaysia</content-line>
            </content-spacer>
          </content-text-block>  
        </content-tout-block>
        <content-tout-block hover="false">
          <content-image slot="media" alt="Test Alt Text" lazy-load="false" width="2" height="3" aspect-ratio="2/3" src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4"></content-image>
          <content-text-block slot="mediaContent" vertical="bottom">
            <content-spacer text-align="left" left-offset="4" bottom-offset="4">
              <content-line classes="text-style--tout-media-content">Tourist Destination</content-line>
              <content-line classes="text-style--tout-media-content">Malaysia</content-line>
            </content-spacer>
          </content-text-block>  
        </content-tout-block>
        <content-tout-block hover="false">
          <content-image slot="media" alt="Test Alt Text" lazy-load="false" width="2" height="3" aspect-ratio="2/3" src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4"></content-image>
          <content-text-block slot="mediaContent" vertical="bottom">
            <content-spacer text-align="left" left-offset="4" bottom-offset="4">
              <content-line classes="text-style--tout-media-content">Tourist Destination</content-line>
              <content-line classes="text-style--tout-media-content">Malaysia</content-line>
            </content-spacer>
          </content-text-block>  
        </content-tout-block>
        
      </content-grid-formatter>
  
    <content-spacer top-offset="5" bottom-offset="5">
      <content-hero-block>
        <content-image slot="background" aspect-ratio="3/4|4/1" src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"></content-image>
        <content-text-block slot="content">
          <content-spacer max-width="100|400px" left-offset="2" top-offset="2">
            <content-line classes="text-style--header">Travel Vlog</content-line>
            <content-line classes="text-style--subheader">Follow along with my guide to the best of this travel destination.</content-line>
            <content-spacer top-offset="2">
              <content-button classes="button button--primary">Explore</content-button>
            </content-spacer>
          </content-spacer>
        </content-text-block>
      </content-hero-block>
    </content-spacer>
    
    <content-grid-formatter type="flex" flex-grow="true" columns="1|2">
      <content-text-block class="content-block--40">
        <content-spacer left-offset="2" right-offset="2" top-offset="2" bottom-offset="4"> 
          <content-line classes="text-style--header">Favorite Destinations</content-line>
          <content-line classes="text-style--subheader">No time to wait</content-line>
          <content-spacer top-offset="2">
            <content-button classes="button button--primary">Travel With Me</content-button>
          </content-spacer>
        </content-spacer>
      </content-text-block>
      <content-image src="https://picsum.photos/1600/900?random=2&grayscale"></content-image>
    </content-grid-formatter>

    
    <content-grid-formatter columns="1|3" type="grid" class="grid--spaced" row-gap="20px" row-gap="20px">
      <content-image src="https://picsum.photos/400/300?random=1&grayscale"></content-image>
      <content-image src="https://picsum.photos/400/300?random=2&grayscale"></content-image>
      <content-image src="https://picsum.photos/400/300?random=3&grayscale"></content-image>
    </content-grid-formatter>

    
      <content-text-block slot="header">
        <content-spacer bottom-offset="20px"><content-line classes="text-style--header-2">Carousel</content-line></content-spacer>
      </content-text-block>
      <content-carousel init-method="load">
      <content-hero-block>
      <content-image slot="background" src="https://picsum.photos/1600/900?random=5&grayscale"></content-image>
      <content-text-block slot="content">
        <content-spacer left-offset="2" top-offset="20px">
          <content-line classes="text-style--header">Japan</content-line>
          <content-line classes="text-style--subheader">Taken amongst the Cherry Blossom trees of Tokyo.</content-line>
          <content-spacer top-offset="2">
            <content-button classes="button button--primary">SHOP NOW</content-button>
          </content-spacer>
        </content-spacer>
      </content-text-block>
    </content-hero-block>

    <content-hero-block>
          <content-image slot="background" src="https://picsum.photos/1600/900?random=5&grayscale"></content-image>
          <content-text-block slot="content">
            <content-spacer left-offset="2" top-offset="20px">
              <content-line classes="text-style--header">Norway</content-line>
              <content-line classes="text-style--subheader">Explore the Northern Lights.</content-line>
              <content-spacer top-offset="2">
                <content-button classes="button button--primary">SHOP NOW</content-button>
              </content-spacer>
            </content-spacer>
          </content-text-block>
        </content-hero-block>
      </content-carousel>
    <content-spacer top-offset="5" bottom-offset="5">
      <content-grid-formatter type="flex" flex-grow="true" columns="1|2">
        <content-tout-block hover="false">
          <content-image slot="background" src="https://picsum.photos/1600/900?random=8&grayscale"></content-image>
          <content-spacer slot="mediaContent" top-offset="8" bottom-offset="5" left-offset="6" right-offset="4">
            <content-text-block color-class="light">
              <content-line classes="text-style--header-2">/Instructions</content-line>
              <content-spacer slot="footer">
                <content-line classes="text-style--small-copy">/01 Twist base of bottle counter-clockwise to lock</content-line>
                <content-line classes="text-style--small-copy">/01 Twist base of bottle counter-clockwise to lock</content-line>
                <content-line classes="text-style--small-copy">/01 Twist base of bottle counter-clockwise to lock</content-line>
                <content-line classes="text-style--small-copy">/01 Twist base of bottle counter-clockwise to lock</content-line>
              </content-spacer>
            </content-text-block>
          </content-tout-block>
        </content-tout-block>
        <content-spacer left-offset="4" class="content-block--35">
          <content-text-block>
            <content-line classes="text-style--header">Editorial Content</content-line>
            <content-line classes="text-style--subheader">Donec sed odio dui. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</content-line>
            <content-spacer top-offset="2">
              <div><content-button classes="link link--large">Learn more ></content-button></div>
            </content-spacer>
          </content-text-block>
        </content-spacer>
      </content-grid-formatter>
    </content-spacer>
    <content-hero-block>
      <content-image slot="background" src="https://picsum.photos/1600/900?random=9&grayscale"></content-image>
      <content-text-block slot="content">
        <content-spacer max-width="90|75|55|35" top-offset="2|8" left-offset="2" right-offset="2|7" horizontal="left|right">
          <content-line classes="text-style--header">Editorial Content</content-line>
          <content-line classes="text-style--subheader">Freeform text layouts.</content-line>
          <content-spacer top-offset="2">
            <div><content-button classes="link link--large">Example CTA</content-button></div>
          </content-spacer>
        </content-spacer>
      </content-text-block>
    </content-hero-block>
  
    <content-spacer top-offset="5" bottom-offset="5">
      <content-hero-block>
        <content-image slot="background" src="https://picsum.photos/1600/900?random=10&grayscale"></content-image>
        <content-text-block slot="content" vertical="center">
          <content-spacer max-width="90|75|55|35" left-offset="2" right-offset="10" horizontal="left">
            <content-line classes="text-style--header">Editorial Content</content-line>
            <content-line classes="text-style--subheader">Donec sed odio dui.</content-line>
            <content-spacer top-offset="2">
              <div><content-button classes="link link--large">Learn more ></content-button></div>
            </content-spacer>
          </content-spacer>
        </content-text-block>
      </content-hero-block>
    </content-spacer>
  </div>`,
};
